import connectPagination from 'instantsearch.js/es/connectors/pagination/connectPagination';
import { getVisiblePages } from '..';

export default function Pagination(container = '#pagination') {
	return connectPagination((renderOptions) => {
		const { currentRefinement, nbPages, isFirstPage, isLastPage, refine } = renderOptions;
		const containerElement = typeof container === 'string' ? document.querySelector(container) : container;
		const totalPages = 3;

		if (nbPages <= 1) {
			containerElement.innerHTML = '';
			return;
		}

		containerElement.innerHTML = `
			<ul class="pagination-list mobile">
				<li class="pagination-item prev-page">
					<a class="no-underline${isFirstPage ? ' pointer-events-none opacity-40' : ''}" data-value="${currentRefinement - 1}">
					<i class="fas fa-arrow-left"></i>
					</a>
				</li>
				<li class="total-pages flex justify-center items-center text-secondary-140 font-bold">
					<span>${currentRefinement + 1} / ${nbPages}</span>
				</li>
				<li class="pagination-item next-page">
					<a class="no-underline${isLastPage ? ' pointer-events-none opacity-40' : ''}" data-value="${currentRefinement + 1}">
					<i class="fas fa-arrow-right"></i>
					</a>
				</li>
			</ul>
			<ul class="pagination-list desktop">
				${
					!isFirstPage
						? `
							<li class="pagination-item prev-page">
								<a class="no-underline" data-value="${currentRefinement - 1}">
								<i class="fas fa-arrow-left"></i>
								</a>
							</li>
							`
						: ''
				}
				${getVisiblePages(currentRefinement, nbPages, totalPages)
					.map((page) => {
						if (page === '...') {
							return `
								<li class="pagination-item ellipsis">
									<span>...</span>
								</li>
							`;
						}
						return `
							<li class="pagination-item ${currentRefinement === page ? 'active-item' : ''}">
								<a class="no-underline" data-value="${page}">
								${page + 1}
								</a>
							</li>
						`;
					})
					.join('')}
					${
						!isLastPage
							? `
								<li class="pagination-item next-page">
									<a class="no-underline" data-value="${currentRefinement + 1}">
									<i class="fas fa-arrow-right"></i>
									</a>
								</li>
								`
							: ''
					}
			</ul>
		`;

		[...containerElement.querySelectorAll('a')].forEach((element) => {
			element.addEventListener('click', (e) => {
				e.preventDefault();
				refine(e.currentTarget.dataset.value);
			});
		});
	})({ container });
}
